import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {map} from 'rxjs/operators';
import {IUser} from '../../../users/users';
import {UsersService} from '../../../users/users.service';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {Observable, of} from 'rxjs';

@Component({
    selector: 'app-user-autocomplete',
    templateUrl: './user-autocomplete.component.html',
    standalone: false
})
export class UserAutocompleteComponent {

  @Input() formGroup: FormGroup;
  @Input() required = true;
  @Input() autocompleteDisabled = false;
  @Input() appearance = 'standard';
  @Input() label = marker('Choose a user');
  @Input() errorRequiredMessage = marker('User is required.');
  @Input() selected: string;
  @Input()  inactive = false;
  @Input()  inactiveMessage = marker('This user is inactive.');
  @Input() noMatchFoundMessage = marker('No user could be matched.');
  @Output() userChanged = new EventEmitter<IUser>();
  @Input() id = 'user';

  constructor(
    private usersService: UsersService,
  ) {
  }

  public filterUsers(name: string): Observable<IUser[]> {
    if(this.usersService) {
      return this.usersService.filterUsersByUserName(name).pipe(
        map(response => response.list)
      );
    }
    return of([]);
  }

  onUserSelected(user: IUser) {
    this.inactive = false;
    this.userChanged.emit(user);
  }
}
